import get from 'lodash/get';

export const getMultipleFieldsData = (label, dataLabel, tableItem) => {
  let fieldLabels = label;
  let fieldValues = (dataLabel || []).map((dataLabel) => get(tableItem, dataLabel));
  return { fieldLabels, fieldValues };
};
